import { api } from './api'

export const fetchChannel = (query) => api.get('/channel', query)
export const addChannel = (channels) => api.post('/channel', channels)
export const updateChannel = (channel) => api.put(`/channel/${channel.id}`, channel)
export const deleteChannel = (channel) => api.delete(`/channel/${channel.id}`)
